import { useEffect, useState } from "react";
import { _single, _UBLInvoice, _UBLItemInvoice } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { BasicTable, MASK_MONEY } from "../../../theme/Component/BasicTable";
import { toast } from "react-toastify";
import { Modal } from "../../../theme/Component/Modal";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { ProductionOrderEditor } from "../../ProductionOrder/ProductionOrderEditor";
import { SelectorUmeasurement } from "../../../bpm/config/Componentes/SelectorUmeasurement";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { MeasurementUnitCodeEditor } from "../../../erp/MeasurementUnitCode/MeasurementUnitCode.editor";

interface Props {
    idUBLInvoice: number;
    issueDate: Date;
    _onChange?: Function;
    updateFunction?: Function;
}

export const UBLInvoiceItemProductionOrder = ({ idUBLInvoice, issueDate, _onChange }: Props) => {

    const { instance, bean, setBean, lista, setLista, handleChange } = useDataBean(_UBLItemInvoice);
    const _ublInvoice = useDataBean(_UBLInvoice)
    const [invoice, setInvoice] = useState<any>({});

    const modifiAnyWay = _single.getSessionItem("canModifiUBL") ? JSON.parse(_single.getSessionItem("canModifiUBL")) : false;

    const [modalC, setModalC] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });

    useEffect(() => {
        if (idUBLInvoice) {
            getInvoice();
            getLista();
        }
    }, [idUBLInvoice])

    const getInvoice = () => {
        _ublInvoice.instance.getUblInvoice(idUBLInvoice, issueDate).then(
            (resp) => {
                setInvoice(resp)
            }
        ).catch(
            err => {
                toast.error(err)
            }
        )
    }

    const generate = () => {
        instance.createProductRowForUBLRemissionInvoice(bean.IDUBLInvoice, bean.IssueDate, bean.IDProductionOrder, bean.ProductionOrderDate, bean.Quantity, bean.Description).then(
            (resp) => {
                console.log(resp)
                getLista();
                setModal({ ...modal, "view": false })
                if (_onChange) {
                    _onChange();
                }
            }
        ).catch(
            err => { toast.error(err) }
        );
    }

    const listaBotones = () => {
        const botones = [
            { titulo: 'Eliminar Item de la Factura', icono: 'ri-delete-bin-2-line', visible: (invoice.SourceType === 7 && (!invoice.ProcessType)), evento: () => { setModalC({ ...modalC, "name": `Eliminar Item ${bean.Description}`, "view": true }) } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const head = [
        { title: 'ID', property: 'IDUBLItemInvoice', visible: true },
        // { title: 'Tipo de Bien/Se', property: 'AdquisitionArticleTypeName', visible: true },
        { title: 'Nombre del Bien o Servicio', property: 'Description', visible: true },
        // { title: 'Unidades', property: 'MeasurementUnitName', visible: true },
        { title: 'Valor Unitario', property: 'UnitaryValue', visible: true, mask: MASK_MONEY },
        { title: 'Cantidad', property: 'Quantity', visible: true },
        { title: 'Subtotal', property: 'PriceValue', visible: true, mask: MASK_MONEY },
        { title: 'Subtotal Impuestos', property: 'TaxAmount', visible: true, mask: MASK_MONEY },
        { title: 'Valor Total', property: 'TotalItemAmount', visible: true, mask: MASK_MONEY },
        { title: 'Ciudad de Bien/Servicio', property: 'SiteIDName', visible: true },
        { title: 'Cuenta Contable', property: 'AccountantIDName', visible: false },
        { title: 'Rubro Presupuestal', property: 'BudgetName', visible: false },
        { title: 'Tipo de Bien', property: 'AssetTypeName', visible: true },
    ]

    const create = () => {
        setBean({
            IDUBLInvoice: idUBLInvoice,
            IssueDate: issueDate,
        })
        setModal({ ...modal, "view": true, "name": "Crear Item de Factura" })
    }

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: () => { create() } }
    ]

    const getLista = () => {
        instance.getUBLItemInvoiceCatalog(idUBLInvoice, issueDate).then(
            (resp) => {

                let tmp = resp;
                tmp.forEach((element: any) => {
                    element.DataBeanProperties.BudgetName = element.DataBeanProperties.BudgetJsconCode + " " + element.DataBeanProperties.BudgetName;
                });
                setLista(tmp)
            }
        )
    }

    const delteItem = () => {
        instance.deleteUBLItemInvoice(bean.IssueDate, bean.IDUBLItemInvoice).then(
            (resp) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )
    }

    return (
        <>
            <div className="row">
                <div className="col-md-6">
                    <strong>Proveedor </strong><small>{invoice.AccountSupplierName}</small>
                </div>
                <div className="col-md-6">
                    <strong>Idenficación </strong><small>{invoice.AccountSupplierNit}</small>
                </div>
                <div className="col-md-6">
                    <strong>Valor </strong><small>{(invoice.TotalInvoiceAmount)}</small>
                </div>
                <div className="col-md-6">
                    <strong>Concepto </strong><small>{invoice.AccountantConceptName}</small>
                </div>
                <div className="col-md-6">
                    <strong>Proceso </strong><small>{invoice.ProcessTypeName}</small>
                </div>
                <div className="col-md-6">
                    <strong>ID Factura </strong><small>{invoice.IDUBLInvoice}</small>
                </div>
                <div className="col-md-6">
                    <strong>Fecha Factura </strong><small>{invoice.IssueDate}</small>
                </div>
            </div>

            <BasicTable listButtons={listaBotones()} iconButtons={iconButtonsItem} body={lista} head={head} rowSet={setBean} />

            <Modal modal={modal} updateModal={setModal} eventModal={generate} >
                <div className="row">
                    <div className="col-md-12">
                        <ProductionOrderEditor IDOrderProduction={0} returnData={(e) => { setBean({ ...bean, "IDProductionOrder": e.IDProductionOrder, "ProductionOrderDate": e.ProductionOrderDate, "Description": e.ProductName, "MeasurementUnitCode": e.IDMeasurementUnitCode, "UBLMeasurementUnitName": e.MeasurementUnitName }); console.log(e) }} />
                    </div>
                    <div className="col-12">
                        <label className={``}>Nombre del Bien o Servicio</label>
                        <textarea disabled={bean.IDProductionOrder} name="Description" className="form-control" value={bean.Description} onChange={handleChange} rows={3} />
                    </div>
                    <div className="col-12">
                        <label className={``}>Cantidad</label>
                        <input disabled={!(modifiAnyWay || invoice.SourceType === 7)} type="number" name="Quantity" className="form-control" value={bean.Quantity} onChange={handleChange} />
                    </div>
                </div>
            </Modal>

            <ModalConfirm eventModal={delteItem} modal={modalC} updateModal={setModalC}>
                <p>Eliminar Item</p>
            </ModalConfirm>
        </>
    )
}